/**
 * ============================================================================
 * SystemLog 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义系统日志（登录日志）相关的所有枚举类型
 * - 包含：统计周期枚举
 * 
 * 📖 对应后端：
 * - Controller: backend/app/Http/Controllers/Api/V1/LogController.php
 * - Model: backend/app/Models/LoginAttempt.php (无常量定义)
 * 
 * ⚠️ 注意事项：
 * - LoginAttempt Model 没有定义 TYPE_* 或 STATUS_* 常量
 * - isSuccessful 是 boolean 类型，不需要枚举
 * - 只定义业务逻辑中用到的枚举
 * 
 * 🔄 更新时机：
 * - 后端新增统计维度时
 * - 后端新增筛选条件时
 * - 业务新增状态/类型时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Http/Controllers/Api/V1/LogController.php
 * 2. 检查所有方法使用的枚举值
 * 3. 确认本文件包含所有必要的枚举
 * 
 * @module types/system-log/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

/**
 * 统计周期枚举
 * 用于 loginStats 和 loginTrend 接口的 period 参数
 * 
 * 对应后端：LogController::loginStats() 和 LogController::loginTrend()
 */
export enum StatisticsPeriod {
  /** 今天 */
  TODAY = 'today',
  /** 本周 */
  WEEK = 'week',
  /** 本月 */
  MONTH = 'month',
  /** 本年 */
  YEAR = 'year',
}

/**
 * 趋势分组方式枚举
 * 用于 loginTrend 接口的 groupBy 参数
 * 
 * 对应后端：LogController::loginTrend()
 */
export enum TrendGroupBy {
  /** 按小时分组 */
  HOUR = 'hour',
  /** 按天分组 */
  DAY = 'day',
}

